
import TableList from "@components/templates/tablelist";
import { HttpManageBillList, HttpExportManageBill, HttpApprovePlanBill, HttpCancelPlanBill } from "@/service/allotment";
import mixin from "../mixin";
import { mapGetters } from "vuex";
export default {
    mixins: [TableList, mixin],
    data() {
        return {
            isMixin: true,
            Tools: { show: true },
            Tabs: { show: true },
            formData: {
                search: {
                    EQ_transferOutboundPlanStatus: null
                }
            },
            Searchs: {
                show: true,
                labelWidth: 90,
            },
            Plugins: { show: true }
        };
    },
    methods: {
        ajaxRequest: HttpManageBillList,
        interceptRequest(params) {
            const { warehouseId, inWarehouseId } = params.search;
            params.warehouseId = warehouseId;
            params.inWarehouseId = inWarehouseId;
            delete params.search.warehouseId;
            delete params.search.inWarehouseId;
            this.formData = params
            return params
        },
        handleOperates(params = "", type, batch) {
            if (batch === true) {
                params = (params || this.checkedData.join(',')) + '';
                if (!params.length) return this.$VMessage.warning(this.$t('global.common.choose_one', { defaultValue: '请选择至少一条数据' }));
            }
            switch (type) {
                case "query":
                    var url = this.$router.resolve({
                        name: "allotUpdateManage",
                        params: { type: "query" },
                        query: { id: params },
                    });
                    window.open(url.href, '_blank');
                    break;
                case "cancel":
                    this.operate = {
                        show: true,
                        alert: "error",
                        title: this.$t('global.common.operate_cancel', { defaultValue: "取消" }),
                        width: 460,
                        showDesc: false,
                        params: { id: params },
                        ajaxRequest: HttpCancelPlanBill,
                        formdata: [
                            {
                                tag: "vTextarea",
                                key: "cancelReason",
                                labelWidth: 'auto',
                                span: 24,
                                label: this.$t('fbb.alloment.cancel_reason', { defaultValue: "取消原因" })
                            }
                        ]
                    };
                    break;
                case "approve":
                    this.operate = {
                        show: true,
                        alert: "info",
                        title: this.$t('fbb.alloment.button_audit', { defaultValue: "审核" }),
                        width: 'middle',
                        showDesc: false,
                        params: {
                            ids: params
                        },
                        ajaxRequest: HttpApprovePlanBill,
                        formdata: [
                            {
                                tag: "vRadio",
                                key: "actionType",
                                span: 24,
                                label: this.$t('fbb.alloment.button_audit', { defaultValue: "审核" }),
                                labelWidth: 120,
                                default: 500,
                                options: [{
                                    label: this.$t('fbb.inbound.pass_audit', { defaultValue: "审核通过" }),
                                    trueValue: 500
                                }, {
                                    label: this.$t('fbb.alloment.refuse', { defaultValue: "驳回" }),
                                    trueValue: 600
                                }]
                            },
                            {
                                label: this.$t('fbb.alloment.warehouse_out_bound_at', { defaultValue: "预计出库日期" }),
                                tag: "vDatepicker",
                                key: "warehouseEstimateOutboundAt",
                                labelWidth: 120,
                                span: 24,
                                props: {
                                    format: "yy-mm-dd",
                                },
                                required: false,
                            },
                            {
                                tag: "vTextarea",
                                key: "reason",
                                labelWidth: 120,
                                span: 24,
                                label: this.$t('global.common.notes', { defaultValue: "备注" }),
                                required: false,
                            }
                        ]
                    };
                    break;
                case 'export':
                    this.handleWebfs(process.env.VUE_APP_APIURL_FBB + '/api/v2/TransferOutboundPlan/batchManagerExport', this.formData, {
                        executor: 'request',
                        download: true,
                        method: 'post',
                    })
                    break;
            }
        },
        getOperateNodeMap(row) {
            const { id, transferOutboundPlanStatus: status } = row
            return [{
                label: this.$t('fbb.alloment.query_detail', { defaultValue: '查看详情' }),
                show: true,
                params: id,
                operate: 'query'
            }, {
                label: this.$t('fbb.alloment.button_audit', { defaultValue: '审核' }),
                show: status == 5,
                params: id,
                operate: 'approve'
            }, {
                label: this.$t('global.common.operate_cancel', { defaultValue: '取消' }),
                show: status == 10,
                params: id,
                operate: 'cancel'
            }]
        },
    },
    computed: {
        ...mapGetters('dictionary', ['getBillcusWareList', 'getCusproductList', 'getOrgList']),
        TabsData() {
            return [
                {
                    name: this.$t('fbb.alloment.all', { defaultValue: '所有' }),
                    key: 'EQ_transferOutboundPlanStatus',
                    value: null
                }, {
                    name: this.$t('fbb.alloment.audit', { defaultValue: "待审核" }),
                    key: 'EQ_transferOutboundPlanStatus',
                    value: 5
                }, {
                    name: this.$t('global.common.canceled', { defaultValue: "已取消" }),
                    key: 'EQ_transferOutboundPlanStatus',
                    value: 110
                }
            ]
        },
        ToolsData() {
            return [
                {
                    name: this.$t('fbb.alloment.muti_audit', { defaultValue: "批量审核" }),
                    operate: "approve",
                    theme: "primary",
                    batch: true,
                }, {
                    name: this.$t('fbb.alloment.muti_export', { defaultValue: "批量导出" }),
                    operate: "export",
                    theme: "info",
                    // batch: true,
                },
            ]
        },
        SearchsData() {
            return [
                {
                    label: this.$t('fbb.alloment.alloment_order_number', { defaultValue: "调拨计划单号" }),
                    tag: 'vInput',
                    key: 'EQ_transferOutboundPlanNo',
                    show: true,
                },
                {
                    label: this.$t('global.common.organization', { defaultValue: "组织" }),
                    tag: 'vSelect',
                    key: 'EQ_organizationId',
                    show: true,
                    options: this.getOrgList,
                    props: {
                        filterable: true,
                    }
                },
                {
                    label: this.$t('global.common.line', { defaultValue: "项目" }),
                    tag: 'vSelect',
                    key: 'EQ_lineId',
                    show: true,
                    options: this.getCusproductList,
                    props: {
                        filterable: true,
                    }
                },

                {
                    label: "Tracking NO",
                    tag: 'vInput',
                    key: 'EQ_trackingNo',
                },

                {
                    label: "Shipment ID",
                    tag: 'vInput',
                    key: 'EQ_shipmentId',
                    // options:[],
                },
                {
                    label: "Remove Order ID",
                    tag: 'vInput',
                    key: "EQ_removeOrderId",
                },
                {
                    label: this.$t('fbb.alloment.order_type', { defaultValue: "单据类型" }),
                    tag: 'vSelect',
                    key: 'EQ_orderType',
                    options: this.getBillType
                },
                {
                    label: this.$t('fbb.inbound.inventory_type', { defaultValue: "库存类型" }),
                    tag: 'vSelect',
                    key: 'EQ_inventoryType',
                    options: this.getInventoryType
                },
                {
                    label: this.$t('fbb.alloment.order_status', { defaultValue: "单据状态" }),
                    tag: 'vSelect',
                    key: 'EQ_transferOutboundPlanStatus',
                    options: this.getBillStatus
                },
                {
                    label: this.$t('fbb.alloment.warehouse_out', { defaultValue: "出库仓库" }),
                    tag: 'vSelect',
                    key: 'warehouseId',
                    options: this.getBillcusWareList,
                    props: {
                        filterable: true,
                    }
                },
                {
                    label: this.$t('fbb.alloment.warehouse_in', { defaultValue: "入库仓库" }),
                    tag: 'vSelect',
                    key: 'inWarehouseId',
                    options: this.getBillcusWareList,
                    props: {
                        filterable: true,
                    }
                },
                {
                    label: this.$t('global.common.source_number', { defaultValue: "来源单号" }),
                    tag: 'vInput',
                    key: 'EQ_sourceNo',
                },
                {
                    label: this.$t('fbb.alloment.warehouse_out_bound_at', { defaultValue: "预计出库日期" }),
                    tag: "vDatepicker",
                    key: "BT_warehouseEstimateOutboundAt",
                    style: "width:362px",
                    props: {
                        format: 'yy-mm-dd ~ yy-mm-dd',
                        confirm: false,
                    },
                },
                {
                    label: this.$t('global.common.createdtime', { defaultValue: "创建日期" }),
                    tag: 'vDatepicker',
                    style: "width:362px",
                    key: 'BT_createdAt',
                    props: {
                        format: 'yy-mm-dd 00:00:00 ~ yy-mm-dd 23:59:59',
                        confirm: false,
                    },
                },

            ]
        },
        columns() {
            return [{
                type: 'selection',
                width: 40,
                align: 'center',
                formName: 'id'
            }, {
                title: this.$t('global.common.operation', { defaultValue: '操作' }),
                maxWidth: 90,
                render: this.getOperateNodes
            }, {
                title: this.$t('global.common.organization', { defaultValue: '组织' }),
                key: 'orgName',
                // render: (h, { row }) => this.findRenderLabel(this.getOrgList, row.organizationId)
            },
            {
                title: this.$t('fbb.alloment.alloment_order_number', { defaultValue: '调拨计划单号' }),
                key: 'transferOutboundPlanNo',
                render: (h, { row }) => {
                    return <a class="color-link" onClick={this.handleOperates.bind(this, row.id, 'query')}>{row.transferOutboundPlanNo}</a>
                }
            },
            {
                title: this.$t('global.common.source_number', { defaultValue: '来源单号' }),
                key: 'sourceNo',
            },
            {
                title: this.$t('fbb.alloment.order_type', { defaultValue: '单据类型' }),
                key: 'orderType',
                width: 80,
                render: (h, { row }) => this.findRenderLabel(this.getBillType, row.orderType)
            },
            {
                title: this.$t('global.common.line', { defaultValue: '项目' }),
                key: 'lineName',
                // render: (h, { row }) => this.findRenderLabel(this.getCusproductList, row.lineId)
            },
            {
                title: this.$t('fbb.alloment.order_status', { defaultValue: '单据状态' }),
                key: 'transferOutboundPlanStatus',
                maxWidth: 80,
                render: (h, { row }) => {
                    const status = row.transferOutboundPlanStatus;
                    const { theme = 'default', label } = this.getBillStatus.find(function (item) {
                        return item.value == status
                    }) || {};
                    return <vButton ghost theme={theme} size="small" class="cursor-not width-60">{label}</vButton>
                }
            },
            {
                title: this.$t('fbb.alloment.warehouse_out', { defaultValue: '出库仓库' }),
                key: 'orgWarehouseCode',
                // template: "orgWarehouseCode"
            },
            {
                title: this.$t('fbb.alloment.warehouse_in', { defaultValue: '入库仓库' }),
                key: 'inOrgWarehouseCode',
                // template: "inOrgWarehouseCode"
            },
            {
                title: this.$t('fbb.inbound.inventory_type', { defaultValue: '库存类型' }),
                key: 'inventoryType',
                width: 80,
                render: (h, { row }) => this.findRenderLabel(this.getInventoryType, row.inventoryType)
            },
            // {
            //     title: 'Shipment ID',
            //     key: 'shipmentId',
            // },
            // {
            //     title: 'Remove Order ID',
            //     key: 'removeOrderId',
            // },
            {
                title: 'Shipment ID / Remove Order ID',
                key: 'shipmentId',
                render(h, { row }) {
                    return <div>
                        <div>Shipment:{row.shipmentId}</div>
                        <div>Remove:{row.removeOrderId}</div>
                    </div>
                }
            },
            {
                title: this.$t('fbb.alloment.date', { defaultValue: '日期' }),
                key: 'createdAt',
                minWidth: 130,
                render(h, { row }) {
                    return <div>
                        <div>{this.$t('global.common.createdtime', { defaultValue: '创建时间' })}:{row.createdAt}</div>
                        <div>{this.$t('fbb.alloment.warehouse_out_bound_at', { defaultValue: '预计出库日期' })}:{row.warehouseEstimateOutboundAt}</div>
                    </div>
                }
            },
            ];
        },

    },

};
